import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef, OnChanges } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { isEmpty, forIn, find } from 'lodash';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'covance-dropdown-select',
    template: require('./covance-dropdown-select.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CovanceSelectDropdownComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public queryParam: string;

    @Input()
    public selectedItem: any;

    @Input()
    public dataSource: Observable<any[]>;

    @Input()
    public items: any[];

    @Input()
    public emptyValue: string;

    @Input()
    public valueGetter: (item: any) => string;

    @Input()
    public textGetter: (item: any) => string;

    @Output()
    public onChange = new EventEmitter<any>();

    private subscription: Subscription;

    constructor(protected router: Router, protected activatedRoute: ActivatedRoute, private changeDetectorRef: ChangeDetectorRef) { }

    public ngOnInit() {
        if (this.dataSource) {
            this.subscription = this.dataSource.subscribe((items) => {
                this.items = items;
                this.selectItemByQueryParam();
                this.changeDetectorRef.markForCheck();
            });
        }
    }

    public ngOnChanges() {
        this.selectItemByQueryParam();
    }

    public change($event: any) {
        const queryParams: Params = {};
        forIn(this.activatedRoute.snapshot.queryParams, (value: string, key: string) => {
            queryParams[key] = value;
        });

        queryParams[this.queryParam] = this.getValue($event);

        this.router.navigate([], {
            queryParams: queryParams,
            relativeTo: this.activatedRoute,
            replaceUrl: true
        });

        this.onChange.emit($event);
    }

    public selectItemByQueryParam() {
        if (!isEmpty(this.items)) {

            if (this.queryParam) {
                const queryParamValue = this.activatedRoute.snapshot.queryParams[this.queryParam];
                const selectedItem = find(this.items, (item: any) => this.getValue(item) === queryParamValue);

                if (selectedItem) {
                    this.selectedItem = selectedItem;
                }
            }

            if (this.onChange) {
                this.onChange.emit(this.selectedItem);
            }
        }
    }

    public ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private getValue(item: any): string {
        if (!item) {
            return item;
        }

        if (this.valueGetter) {
            return this.valueGetter(item);
        }

        return item;
    }

    private getText(item: any): string {
        if (this.textGetter) {
            return this.textGetter(item);
        }

        return this.getValue(item);
    }
}